import { isMarketUrl } from 'APP/Tasks/market/isMarketUrl';

import { getMarketConfig, stopUpdateMarketConfig } from './marketToken';

export default {
  stopUpdateMarketConfig,
  getMarketConfig,
  isMarketUrl,
};
